import React, { Component } from "react";
import { alert, loading, t } from "../../components/CustomComponent.js";
import { withRouter } from "../../components/withRouter.js";

import HomeNavbar from "./components/HomeNavbar.js";
import HomeFooter from "./components/HomeFooter.js";
import PartnerField from "./components/PartnerField.js";

import ICON from "./icons.js";
import { openFreePost, openPartner } from "./options.js";
import { PARTNER_STATUS_STEPS, statusStep, statusTone } from "./partner_option.js";
import { trackPartner } from "../../services/partner.service.js";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
import "../../assets/css/homepage.css";
import "../../assets/css/partner.css";

/* ============================================================================
 * PartnerStatus — ติดตามสถานะใบสมัคร (/partner/status)
 *
 * ตอนนี้ระบบยังส่งอีเมลแจ้งผลจริงไม่ได้ (ยังไม่ได้ตั้งค่า SMTP) ผู้สมัครที่ส่งใบไปแล้ว
 * จึงไม่มีทางรู้ผลเลยนอกจากโทรมาถาม หน้านี้ปิดช่องว่างนั้นด้วยการให้เขามาเช็กเอง
 * และยังมีประโยชน์ต่อไปแม้เปิดอีเมลแล้ว — เมลหายเข้าถังขยะเป็นเรื่องปกติ
 *
 * ต้องกรอกทั้ง "เลขที่ใบสมัคร" และ "อีเมลที่ใช้สมัคร" คู่กัน :
 * เลขที่ใบสมัครเรียงกันเป็นชุด (PT-YYMM-0001) ถ้าถามด้วยเลขที่อย่างเดียว
 * ใครก็ไล่ดูสถานะของผู้สมัครทุกคนได้ — server บังคับเงื่อนไขนี้อีกชั้น
 *
 * รับเลขที่ใบสมัครจาก query string ได้ (?code=PT-...) หน้าจบของฟอร์มสมัครจึงลิงก์
 * มาที่นี่พร้อมเลขที่กรอกให้แล้ว เหลือแค่พิมพ์อีเมล
 * ========================================================================== */
class PartnerStatus extends Component {
  state = {
    code: "",
    email: "",
    errors: {},
    sending: false,
    result: null,
  };

  componentDidMount() {
    document.title = `${t("partner_status_title")} | SafeSpace Life Living`;
    // ปิดตัวหมุนโหลดที่คลุมจอมาตั้งแต่เปิดเว็บ — หน้านี้ยิง API ต่อเมื่อกดค้นหา ไม่มีใครปิดให้
    loading(false);
    window.scrollTo({ top: 0 });

    // เลขที่ใบสมัครที่ส่งต่อมาจากหน้าจบของฟอร์ม — เติมให้เลย ไม่ต้องพิมพ์ซ้ำ
    const code = new URLSearchParams(window.location.search).get("code");
    if (code) this.setState({ code: code.trim().toUpperCase() });
  }

  setField = (patch) =>
    this.setState((state) => {
      const errors = { ...state.errors };
      Object.keys(patch).forEach((key) => delete errors[key]);
      // แก้ค่าแล้วผลเดิมใช้ไม่ได้อีก ล้างทิ้งทันที ไม่ให้เข้าใจผิดว่าเป็นผลของค่าใหม่
      return { ...patch, errors, result: null };
    });

  validate = () => {
    const errors = {};
    if (!this.state.code.trim()) errors.code = "partner_status_require_code";
    if (!this.state.email.trim()) errors.email = "partner_status_require_email";
    else if (!/^\S+@\S+\.\S+$/.test(this.state.email.trim())) errors.email = "partner_invalid_email";

    this.setState({ errors });
    return !Object.keys(errors).length;
  };

  Search = async () => {
    if (this.state.sending || !this.validate()) return;

    this.setState({ sending: true });
    loading(true);
    const result = await trackPartner(this.state.code, this.state.email);
    loading(false);
    this.setState({ sending: false });

    // POST เด้งข้อความจาก API ให้แล้วเมื่อไม่สำเร็จ จึงไม่ต้องเตือนซ้ำ
    if (result?.status !== true) return;

    this.setState({ result: result.data }, () =>
      // ผลลัพธ์อยู่ใต้ฟอร์ม บนมือถือถ้าไม่เลื่อนให้จะไม่เห็นว่ามีอะไรขึ้นมา
      document.querySelector(".hm-pt-result")?.scrollIntoView({ behavior: "smooth", block: "center" })
    );
  };

  soon = (name) => alert("", "info", t("coming_soon_title"), `${name} — ${t("coming_soon_desc")}`, t("confirm"));

  /* แถบขั้นตอน — ขั้นที่ผ่านมาแล้วติ๊กถูก ขั้นปัจจุบันเน้นสี ที่เหลือเป็นสิ่งที่จะเกิดต่อไป
     ใบที่ไม่อนุมัติไม่มีขั้นถัดไป จึงไม่วาดแถบนี้เลย (ดู renderResult) */
  renderTrack = (status) => {
    const current = statusStep(status);

    return (
      <div className="hm-pt-track">
        {PARTNER_STATUS_STEPS.map((step, i) => (
          <div
            key={step.key}
            className={`hm-pt-track__item ${i < current ? "is-done" : ""} ${i === current ? "is-current" : ""}`}
          >
            <span className="hm-pt-track__dot">
              {i < current ? <span className="hm-ico">{ICON.check}</span> : i + 1}
            </span>
            <div className="hm-pt-track__text">
              <b>{t(step.label)}</b>
              <span>{t(step.desc)}</span>
            </div>
          </div>
        ))}
      </div>
    );
  };

  renderResult = () => {
    const { result } = this.state;
    if (!result) return null;

    const tone = statusTone(result.status);
    const isRejected = result.status === "rejected";
    const isApproved = result.status === "approved";

    return (
      <div className="hm-pt-result">
        <div className={`hm-pt-result__head hm-pt-result__head--${tone}`}>
          <span className="hm-pt-result__code">{result.code}</span>
          <b className="hm-pt-result__status">{t(`partner_status_${result.status}`)}</b>
          <span className="hm-pt-result__desc">{t(`partner_status_${result.status}_desc`)}</span>
        </div>

        {/* เหตุผลต้องมาก่อนอย่างอื่น — คนที่เปิดหน้านี้เจอ "ไม่อนุมัติ" อยากรู้ว่าทำไมทันที */}
        {!!result.reject_reason && (
          <div className="hm-pt-result__reason">
            <span className="hm-ico">{ICON.info}</span>
            <div>
              <b>{t("partner_status_reason")}</b>
              <p>{result.reject_reason}</p>
            </div>
          </div>
        )}

        {!isRejected && this.renderTrack(result.status)}

        {/* อนุมัติแล้ว = เข้าสู่ระบบได้เลย ต้องบอกให้ชัดว่าใช้อะไรเข้า ไม่ใช่ปล่อยให้เดา */}
        {isApproved && (
          <div className="hm-pt-result__cta">
            <p>{t("partner_status_approved_hint")}</p>
            <a className="hm-btn hm-btn--primary" href="/">
              <span className="hm-ico">{ICON.user}</span>
              {t("sign_in")}
            </a>
          </div>
        )}

        {isRejected && (
          <div className="hm-pt-result__cta">
            <p>{t("partner_status_rejected_hint")}</p>
            <button
              type="button"
              className="hm-btn hm-btn--primary"
              onClick={() => openPartner(this.props.router.navigate)}
            >
              <span className="hm-ico">{ICON.handshake}</span>
              {t("partner_status_reapply")}
            </button>
          </div>
        )}
      </div>
    );
  };

  render() {
    const { code, email, errors, sending, result } = this.state;

    return (
      <div className="mn-home">
        <HomeNavbar onPost={openFreePost} />

        <section className="hm-pt">
          <div className="hm-container">
            <div className="hm-pt__head">
              <span className="hm-pt__kicker">{t("partner_kicker")}</span>
              <h1 className="hm-pt__title">{t("partner_status_title")}</h1>
              <p className="hm-pt__desc">{t("partner_status_desc")}</p>
            </div>

            <div className="hm-pt__layout hm-pt__layout--narrow">
              <div className="hm-pt__main">
                <div className="hm-pt-card">
                  <div className="hm-pt-card__body">
                    <div className="hm-pt-grid">
                      <PartnerField label={t("partner_status_code")} required error={errors.code}>
                        <input
                          type="text"
                          className="hm-pt-input"
                          placeholder="PT-2608-0001"
                          value={code}
                          /* เลขที่ใบสมัครเป็นตัวพิมพ์ใหญ่เสมอ — แปลงให้เลยจะได้ไม่ต้อง
                             ให้ผู้ใช้มานั่งเดาว่าพิมพ์เล็กแล้วจะหาไม่เจอหรือเปล่า */
                          onChange={(e) => this.setField({ code: e.target.value.toUpperCase() })}
                          onKeyUp={(e) => e.key === "Enter" && this.Search()}
                        />
                      </PartnerField>

                      <PartnerField label={t("partner_status_email")} required error={errors.email}>
                        <input
                          type="email"
                          className="hm-pt-input"
                          placeholder={t("partner_email_placeholder")}
                          value={email}
                          onChange={(e) => this.setField({ email: e.target.value })}
                          onKeyUp={(e) => e.key === "Enter" && this.Search()}
                        />
                      </PartnerField>
                    </div>

                    <p className="hm-pt-note hm-pt-note--muted mb-3">
                      <span className="hm-ico">{ICON.shield}</span>
                      {t("partner_status_privacy")}
                    </p>

                    <button
                      type="button"
                      className="hm-btn hm-btn--primary w-100"
                      disabled={sending}
                      onClick={this.Search}
                    >
                      <span className="hm-ico">{ICON.search}</span>
                      {sending ? t("partner_status_searching") : t("partner_status_search")}
                    </button>

                    {this.renderResult()}
                  </div>
                </div>
              </div>

              <aside className="hm-pt__side">
                <div className="hm-pt-aside hm-pt-aside--tint">
                  <div className="hm-pt-aside__title">
                    <span className="hm-ico">{ICON.headset}</span>
                    {t("partner_help_title")}
                  </div>
                  <p className="hm-pt-aside__desc">{t("partner_status_help_desc")}</p>
                  <button type="button" className="hm-btn hm-btn--ghost hm-btn--sm" onClick={openFreePost}>
                    <span className="hm-ico">{ICON.comment}</span>
                    {t("partner_help_cta")}
                  </button>
                </div>

                {/* ยังไม่ได้สมัคร แต่หลงเข้ามาหน้านี้ — พาไปที่ควรอยู่ */}
                {!result && (
                  <div className="hm-pt-aside">
                    <div className="hm-pt-aside__title">{t("partner_status_no_code_title")}</div>
                    <p className="hm-pt-aside__desc">{t("partner_status_no_code_desc")}</p>
                    <button
                      type="button"
                      className="hm-btn hm-btn--ghost hm-btn--sm"
                      onClick={() => openPartner(this.props.router.navigate)}
                    >
                      <span className="hm-ico">{ICON.handshake}</span>
                      {t("partner_cta")}
                    </button>
                  </div>
                )}
              </aside>
            </div>
          </div>
        </section>

        <HomeFooter
          data={{}}
          socials={[]}
          onLink={(key) => this.soon(t(key))}
          onSubscribe={() => this.soon(t("home_footer_subscribe"))}
        />
      </div>
    );
  }
}

export default withRouter(PartnerStatus);
